export default __webpack_public_path__ + "static/media/8166-laundry-illustration-animation.69b98f4a.gif";